import React, { useEffect, useState, useRef } from 'react';
import Input from '../../../FlyfishComponents/Input';
import styled from 'styled-components';
import EcomChats from './EcomChats';
import TimeUtil from '../../../../Utils/TimeUtil';
import {
	getDiscount,
	saveStateSession,
} from '../../../FlyfishComponents/flyfishutils/utils';
import ChatLoader from '../ChatLoader';
import Checkbox from '../../../FlyfishComponents/Checkbox';
import Button from '../../../FlyfishComponents/Button';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import Axios from 'axios';
import { TrendingIcon } from '../../../FlyfishComponents/flyfishIcons/icons';
import { loadStateSession } from '../../../FlyfishComponents/flyfishutils/utils';
import SFModal from '../../../BaseComponents/SFModal';
import MessageFeedbackComment from '../../MessageFeedback/MessageFeedbackComment';
const EcomContainer = styled.div`
	position: relative;
	font-family: var(--fontFamily);
	@media screen and (max-width: 800px) {
		& > .chat-loader {
			& > .ff-chatloader-container {
				width: 86vw !important;
				margin-right: 0 !important;
				margin-left: 36px !important;
			}
		}
		& > .options {
			& > .querytext-holder {
				top: -38px !important;
				margin-right: 2px !important;
				width: 86vw !important;
			}
		}
	}
	& > .chat-loader {
		border-bottom: 1px solid #c6c4c4;
		background-color: #f7f7f7;
		height: 54px;
		display: flex;
		justify-content: center;
		align-items: center;
		& > .ff-chatloader-container {
			width: 70vw;
			justify-content: flex-start;
			margin-right: 36px;
			margin-left: 0;
		}
	}
	& > .options {
		display: flex;
		justify-content: center;
		z-index: 2;
		gap: 10px;
		position: relative;
		height: 0;
		& > .placeholder-filter {
			display: flex;
			visibility: hidden;
			font-size: 13px;
		}
		& > .querytext-holder {
			z-index: 2;
			width: 70vw;
			box-shadow: 0px 3px 6px #00000029;
			border-radius: 7px;
			padding: 16px 0;
			position: absolute;
			top: -7px;
			background: white;
			margin-right: 69px;
			font-family: var(--fontFamily);
			& > .not-found {
				font-family: var(--fontFamily);
				text-align: center;
			}
			& > .user-query-bot-response {
				color: #432325;
				& > div {
					padding: 8px 16px;
					&.user-query {
						padding-left: 42px;
					}
					&.bot-response {
						display: flex;
						align-items: center;
						gap: 10px;
						& > svg {
							min-width: 14px;
						}
						& > div {
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							overflow: hidden;
							font-size: 16px;
							font-weight: 500;
							margin: 0;
						}

						&:hover {
							background-color: rgba(0, 0, 0, 0.05) !important;
							cursor: pointer;
						}
					}
				}
			}
			& > hr {
				background: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
				height: 1px;
				border: none;
			}
			& > .trending-advisor-holder {
				display: grid;
				grid-template-columns: auto auto;
				padding: 16px;
				font-size: 16px;
				font-family: var(--fontFamily);
				padding-bottom: unset;
				& > .trending {
					>.trending-item{
						display: flex;
						justify-content: flex-start;
						align-items: center;
						margin-bottom: 5px;
						cursor:pointer;
						>div{
							margin-left: 6px;
						}
					}
					& > div:first-child {
						letter-spacing: 0.73px;
						color: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
						font-size: 14px;
						margin-bottom: 10px;
					}
					>.
				}
				& > .style-advisor {
					& > div:first-child {
						letter-spacing: 0.73px;
						color: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
						font-size: 14px;
						
					}
				}
			}
		}
	}
`;

const EcomThemeDiv = styled.div`
	@media screen and (max-width: 800px) {
		& > .filter {
			right: 7% !important;
			position: absolute;
			top: 41px;
		}
		& > .ff-ecom-input {
			height: 70px;
			width: 86vw !important;
		}
		& > .back-button {
			top: 54px !important;
			left: 6.9% !important;
		}
	}
	position: relative;
	display: flex;
	background-color: ${(props) =>
		props.colorMode === 'dark' ? 'var(--colorScale-9)' : 'var(--colorScale-8)'};
	justify-content: center;
	gap: 10px;
	& > .filter {
		z-index: 2;
		display: flex;
		align-items: center;
		font-size: 14px;
		color: ${(props) =>
		props.colorMode === 'dark' ? '#262626' : 'var(--colorScale-0)'};
		&.show {
			visibility: initial;
			pointer-events: initial;
		}
		&.hide {
			visibility: hidden;
			pointer-events: none;
		}
		& > div {
			&:nth-of-type(1) {
				position: relative;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				> div {
					&:nth-of-type(1) {
						display: flex;
						z-index: 9999;
						cursor: pointer;
					}
					.ff-button-filter {
						display: flex;
						justify-content: center;
						align-items: center;
						.custom-button {
							width: 92%;
							margin-bottom: 10px;
						}
						.custom-button .MuiButton-root {
							width: 100%;
							background-color: var(--selectedColor);
						}
					}
					&:nth-of-type(2) {
						border: 1px solid var(--selectedColor);
						border-radius: 7px;
						background-color: #f5f5f5;
						position: absolute;
						top: 53px;
						right: 0;
						z-index: 1;
						.MuiFormControlLabel-root {
							display: flex;
							flex-direction: row-reverse;
							justify-content: space-between;
							align-items: center;
							margin-left: unset;
							margin-right: unset;
							border-top: 2px solid var(--colorScale-3-1f);
							padding-left: 13px;
							padding-right: 6px;
							&:first-child {
								border: none;
							}
						}
						.MuiFormControlLabel-root .MuiFormControlLabel-label {
							white-space: nowrap;
							> .ff-chatbot-body2 {
								font-weight: 600;
							}
						}
						.MuiButtonBase-root.Mui-checked {
							color: var(--selectedColor);
						}
					}
				}
			}
		}
	}
	& > .back-button {
		position: absolute;
		top: 16px;
		left: 3%;
		display: flex;
		align-items: center;
		gap: 10px;
		cursor: pointer;
		z-index: 1;
	}

	& > .ff-ecom-input {
		padding: 8px 0;
		width: 70vw;
		z-index: 1;
		& > .ff-input {
			max-width: 100%;
			padding: unset;
			.MuiInputBase-root {
				position: relative;
				background: white;
				padding-right: 11px !important;
				padding-left: 17px !important;
				padding-top: 8px !important;
				padding-bottom: 8px !important;
				border-radius: 8px;
				line-height: 1.5;
				color: var(--black);
				& .chat-icon-svg {
					cursor: pointer;
					&.enable {
						& > g {
							& > path {
								fill: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
							}
							& > path:first-child {
								fill: none;
								stroke: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
							}
						}
					}
					&.active {
						& > g {
							& > path {
								fill: #fff;
							}
							& > path:first-child {
								fill: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
								stroke: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
							}
						}
					}
					:not(.active):not(.disable):hover {
						& > g {
							& > path {
								fill: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
							}
							& > path:first-child {
								fill: none;
								stroke: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
							}
						}
					}
				}
				& .division {
					background-color: var(--black-20);
				}
				&.Mui-error {
					.MuiOutlinedInput-notchedOutline {
						border-color: var(--vibrant-pink-400);
					}
					& .division {
						background-color: var(--vibrant-pink-400);
					}
				}
				&:not(.Mui-disabled, .Mui-error).Mui-focused {
					.MuiOutlinedInput-notchedOutline {
						border-color: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
					}
					& .division {
						background-color: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
						width: 2px !important;
					}
				}
				&:not(.Mui-focused, .Mui-disabled, .Mui-error):hover {
					.MuiOutlinedInput-notchedOutline {
						border-color: var(--black-40);
					}
					& .division {
						background-color: var(--black-40);
					}
				}
			}
		}
	}
`;

type Props = {
	token: string;
	tenantId: string;
	botId: string | number;
	country: string;
	secondAPI: boolean;
	colorMode: string;
	encryptText: Function;
	changeToken: Function;
	popUpSnackBar;
	handleToaster;
	enableStyleAdvisor;
	advisorTitle;
};

const EcomNewSearch = ({
	token,
	tenantId,
	botId,
	country,
	secondAPI,
	colorMode,
	encryptText,
	changeToken,
	popUpSnackBar,
	handleToaster,
	enableStyleAdvisor,
	advisorTitle
}: Props) => {
	const [queryText, setQueryText] = useState('');
	const [showChat, setShowChat] = useState(false);
	const [message, setMessage] = useState('');
	const [time, setTime] = useState('');
	const [loader, setLoader] = useState(false);
	const [metaData, setMetaData] = useState<any>();
	const [chatMessages, setChatMessages] = useState([]);
	const [showExistingQueries, setShowExistingQueries] = useState(false);
	const [showBackButton, setShowBackButton] = useState(false);
	const [showCart, setShowCart] = useState(false);
	const [reasonAPIPayload, setReasonAPIPayload] = useState<any>();
	const [responseId, setResponseId] = useState(0);
	const [response, setResponse] = useState<any>();
	const [filterCheckboxValues, setFilterCheckboxValues] = useState('');
	const [showFilter, setShowFilter] = useState(false);
	const [failedCount, setFailedCount] = useState(0);
	const [trendingSearch, setTrendingSearch] = useState([]);
	const [selectedProductData, setSelectedProductData] = useState<any>();
	const [styleAdvisor, setStyleAdvisor] = useState<any>();
	const [styleAdvisorCache, setStyleAdvisorCache] = useState<any>([]);
	const [title, setTitle] = useState('');
	const [categoriesProductsArray, setCategoriesProductsArray] = useState<any>();
	const [update, setUpdate] = useState(false);
	const [selectedMessageIndex, setSelectedMessageIndex] = useState(0);
	const [topProductsRowsCounter, setTopProductsRowsCounter] = useState(1);
	const [thumbFilledUp, setThumbFilledUp] = useState(null);
	const [feedbackMsgId, setfeedbackMsgId] = useState<any>();
	const [msgId, setMsgId] = useState<any>();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [lastProduct, setLastProduct] = useState(false);
	const filterArray = [
		// 'Filter by Customer Ratings',
		'Sort by Newest Arrivals',
		'Sort by Price Low to High',
		'Sort by Price High to Low',
		// 'Sort by Deals and Discounts',
	];
	useEffect(() => {
		if (failedCount === 1) {
			restartSession();
		}
	}, [failedCount]);
	const filterRef = useRef(null);
	const optionsRef = useRef(null);
	useEffect(() => {
		saveStateSession('FF-topProducts-counter', 1);
		Axios.get(
			`${window['BASE_URL']}/analytics/bot/${botId}/trending-search`,

			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		).then((resp: any) => {
			setTrendingSearch(resp.data.queries);
		});
	}, []);
	useEffect(() => {
		if (lastProduct) {
			setTimeout(() => {
				let message = [];
				let chatMessageDataUser = {
					message: queryText,
					timeStamp: TimeUtil.getCurrentTime(new Date()),
					key: null,
					messageType: 'user',
					customInfos: {},
					suggestionChips: [],
				};

				let chatMessageDataServer = {
					message: { ...response, metaData: metaData },
					timeStamp: TimeUtil.getCurrentTime(new Date()),
					key: null,
					messageType: 'server',
					customInfos: {},
					suggestionChips: [],
					conversationalId: response.id,
					thumbFilledUp: null,
					messageId: response.messageId,
				};

				message.push({ chatMessageDataUser, chatMessageDataServer });
				setChatMessages((prev) => [...prev, message]);
			}, 2000);
		}
	}, [lastProduct]);
	useEffect(() => {
		if (showChat) {
			let array = [];
			metaData &&
				metaData.categories &&
				metaData.categories.map((category, categoryIndex) => {
					if (categoryIndex !== 0) {
						let payload = {
							input_text: queryText,
							bot_id: botId,
							tenant_id: tenantId,
							version: 'prod',
							conversationId: responseId,
							category: category,
						};

						Axios.post(
							`${window['BASE_URL']}/llmconnector/complimentary_products`,
							payload,
							{
								headers: {
									'x-tenant-id': tenantId,
									Authorization: `Bearer ${token}`,
								},
							}
						).then((resp: any) => {
							let categoryWithResp = {
								category: category,
								products: resp.data,
								rows: 1,
							};
							array.push(categoryWithResp);

							if (categoryIndex === metaData.categories.length - 1) {
								let finalArray = [
									{
										category:
											metaData && metaData.categories && metaData.categories[0],
										products: metaData && metaData.products,
										rows: loadStateSession('FF-topProducts-counter'),
									},
									...array,
								];

								if (queryText !== loadStateSession('queryText')) {
									setCategoriesProductsArray(finalArray);
								}
							}
						});
					}
				});
		}
	}, [showChat, update]);

	const openThumbsPopup = (val, up, id) => {
		setThumbFilledUp(up);
		setfeedbackMsgId(id);
		setIsModalVisible(val);
	};

	const storeStyle = () => {
		if (styleAdvisor.length > 0)
			setStyleAdvisorCache([
				...styleAdvisorCache,
				{ id: loadStateSession('FF-productID'), data: styleAdvisor },
			]);
	};
	const handleServerResponse = (
		query,
		appendArray,
		lastData,
		convId,
		msgId
	) => {
		setShowChat(false);
		let queryFromPD = false;

		setShowExistingQueries(false);
		setShowCart(false);
		if (showBackButton) {
			queryFromPD = true;
		} else {
			queryFromPD = false;
		}
		setShowBackButton(false);

		let message = [];

		// setQueryText('');
		let payload = {
			search_input: query,
			version: 'prod',
			product_intent: '',
			conversationId: convId,
			messageId: msgId,
			source: 'web',
			bot_id: botId,
			tenant_id: tenantId,
		};

		setReasonAPIPayload(payload);
		setLoader(true);

		fetch(`${window['BASE_URL']}/search/products`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		})
			.then((data) => data.json())
			.then((response) => {
				setSelectedProductData('');
				if (response.status && response.status.toLowerCase() !== 'success') {
					throw new Error(response.message);
				}
				if (!response.status) {
					throw new Error(response.message);
				}
				if (response.status.toLowerCase() === 'success') {
					setFailedCount(0);
					setMsgId(response.messageId);
					setResponse(response);
					setResponseId(response.id); // same as conversation id hence using the same not using from App.tsx

					if (
						response.message.toLowerCase().indexOf('something went wrong') > -1
					) {
						setMessage(
							'We are facing some technical issues in getting the result. Please try again'
						);
					} else {
						setMessage(response.message);
					}
					if (
						(response.metaData.products &&
							response.metaData.products.length > 0) ||
						!queryFromPD
					) {
						setMetaData(response.metaData);
						if (appendArray) {
							setMetaData((prevMetaData) => ({
								...prevMetaData,
								products: prevMetaData.products.concat(
									response.metaData.products
								),
							}));
							if (lastData) {
								setLastProduct(true);
							} else {
								setLastProduct(false);
							}
							setTimeout(() => {
								setCategoriesProductsArray((prevArray) => [
									{
										...prevArray[0],
										products: [
											...prevArray[0].products,
											...(response.metaData.products || []),
										],
									},
								]);
							}, 1000);
						} else
							setCategoriesProductsArray([
								{
									category:
										response.metaData &&
										response.metaData.categories &&
										response.metaData.categories[0],
									products: response.metaData && response.metaData.products,
									rows: 1,
								},
							]);
					}

					setShowChat(true);
					setLoader(false);
				}
			})
			.catch((error) => {
				let offlineMessage;
				setFailedCount(failedCount + 1);

				if (error.message) {
					offlineMessage =
						error.message.toLowerCase().indexOf('limit') > -1
							? error.message
							: '';
					if (
						error.message.toLowerCase() === 'failed to fetch' &&
						failedCount !== 1
					) {
						offlineMessage = `Couldn't connect to the server. Please Retry. If the issue persist check your connection and try again later.`;
					}
				}

				if (!navigator.onLine) {
					setMessage('Seems like you are not connected to a network.');
				} else {
					if (failedCount !== 1) {
						setMessage(
							offlineMessage.length > 0
								? offlineMessage
								: `Couldn't connect to the server. Please Retry. If the issue persist check your connection and try again later.`
						);
					}
				}
				setShowChat(true);
				setLoader(false);
				setTime(TimeUtil.getCurrentTime(new Date()));
				setMetaData('');
			});
	};
	const submitChat = () => {
		setShowChat(false);
		let queryFromPD = false;

		setShowExistingQueries(false);
		setShowCart(false);
		if (showBackButton) {
			queryFromPD = true;
		} else {
			queryFromPD = false;
		}
		setShowBackButton(false);

		let message = [];
		let chatMessageDataUser = {
			message: queryText,
			timeStamp: TimeUtil.getCurrentTime(new Date()),
			key: null,
			messageType: 'user',
			customInfos: {},
			suggestionChips: [],
		};
		// setQueryText('');
		let payload = {
			id: responseId,
			message: queryText,
			botId: botId.toString(),
			version: 'prod',
			country: country,
			metaData: selectedProductData ? selectedProductData : null,
		};

		setReasonAPIPayload(payload);
		setLoader(true);
		let resp = {
			search_input: [
				{
					query: 'show me jeans',
					size: '',
					color: '',
				},
				{
					query: 'show me shirts',
					size: '',
					color: '',
				},
			],
			product_intent: '',
			conversationId: 15995,
			messageId: 75406,
		};
		fetch(
			window['BASE_URL'] + '/conversation/message',
			//(loadStateSession('message_api_url') ?? '/messages/'),
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'x-tenant-id': tenantId,
					Channel: `whatsapp`,
				},
				body: JSON.stringify(payload),
			}
		)
			.then((data) => data.json())
			.then((response) => {
				for (let i = 0; i < response.search_input.length; i++) {
					handleServerResponse(
						response.search_input[i],
						i > 0 ? true : false,
						response.search_input.length - 1 == i ? true : false,
						response.conversationId,
						response.messageId
					);
				}
			});

		// fetch(
		// 	window['BASE_URL'] +
		// 		(loadStateSession('message_api_url') ?? '/messages/'),
		// 	{
		// 		credentials: 'include',
		// 		method: 'POST',
		// 		headers: {
		// 			'Content-Type': 'application/json',
		// 			'x-tenant-id': tenantId,
		// 			Authorization: `Bearer ${token}`,
		// 		},
		// 		body: JSON.stringify(payload),
		// 	}
		// )
		// 	.then((data) => data.json())
		// 	.then((response) => {
		// 		setSelectedProductData('');
		// 		if (response.status && response.status.toLowerCase() !== 'success') {
		// 			throw new Error(response.message);
		// 		}
		// 		if (!response.status) {
		// 			throw new Error(response.message);
		// 		}
		// 		if (response.status.toLowerCase() === 'success') {
		// 			setFailedCount(0);
		// 			setMsgId(response.messageId);
		// 			let chatMessageDataServer = {
		// 				message: response,
		// 				timeStamp: TimeUtil.getCurrentTime(new Date()),
		// 				key: null,
		// 				messageType: 'server',
		// 				customInfos: {},
		// 				suggestionChips: [],
		// 				conversationalId: response.id,
		// 				thumbFilledUp: null,
		// 				messageId: response.messageId,
		// 			};
		// 			setResponseId(response.id); // same as conversation id hence using the same not using from App.tsx
		// 			setTime(chatMessageDataServer.timeStamp);
		// 			if (
		// 				response.message.toLowerCase().indexOf('something went wrong') > -1
		// 			) {
		// 				setMessage(
		// 					'We are facing some technical issues in getting the result. Please try again'
		// 				);
		// 			} else {
		// 				setMessage(response.message);
		// 			}
		// 			if (
		// 				(response.metaData.products &&
		// 					response.metaData.products.length > 0) ||
		// 				!queryFromPD
		// 			) {
		// 				setMetaData(response.metaData);
		// 				setCategoriesProductsArray([
		// 					{
		// 						category:
		// 							response.metaData &&
		// 							response.metaData.categories &&
		// 							response.metaData.categories[0],
		// 						products: response.metaData && response.metaData.products,
		// 						rows: 1,
		// 					},
		// 				]);
		// 			}

		// 			message.push({ chatMessageDataUser, chatMessageDataServer });
		// 			setChatMessages((prev) => [...prev, message]);
		// 			setShowChat(true);
		// 			setLoader(false);
		// 		}
		// 	})
		// 	.catch((error) => {
		// 		let offlineMessage;
		// 		setFailedCount(failedCount + 1);

		// 		if (error.message) {
		// 			offlineMessage = error.message;
		// 			if (
		// 				error.message.toLowerCase() === 'failed to fetch' &&
		// 				failedCount !== 1
		// 			) {
		// 				offlineMessage = `Couldn't connect to the server. Please Retry. If the issue persist check your connection and try again later.`;
		// 			}
		// 		}

		// 		if (!navigator.onLine) {
		// 			setMessage('Seems like you are not connected to a network.');
		// 		} else {
		// 			if (failedCount !== 1) {
		// 				setMessage(
		// 					offlineMessage.length > 0
		// 						? offlineMessage
		// 						: `Couldn't connect to the server. Please Retry. If the issue persist check your connection and try again later.`
		// 				);
		// 			}
		// 		}
		// 		setShowChat(true);
		// 		setLoader(false);
		// 		setTime(TimeUtil.getCurrentTime(new Date()));
		// 		setMetaData('');
		// 	});
	};
	useEffect(() => {
		function handleClickOutside(event) {
			if (filterRef.current && !filterRef.current.contains(event.target)) {
				setShowFilter(false);
			}
			if (optionsRef.current && !optionsRef.current.contains(event.target)) {
				setShowExistingQueries(false);
			}
		}

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [filterRef, optionsRef]);
	useEffect(() => {
		console.log(categoriesProductsArray);
	}, [categoriesProductsArray]);
	const showBack = () => {
		setShowBackButton(true);
		setTitle('');
	};
	const handleStyleAdvisor = (product_id, product_name) => {
		setStyleAdvisor('');
		Axios.post(window['BASE_URL'] + `/llmconnector/style_advisor`, {
			products: [product_id],
			bot_id: botId.toString(),
			version: 'prod',
			id: responseId.toString(),
		},
			{
				headers: {
					'x-tenant-id': loadStateSession('tenantId'),
				},
			}
		).then((response) => {
			const resp = response.data;
			getStyleAdvisor(resp, product_id);
			// setComplimentaryProducts(resp)
		});
	};

	const getStyleAdvisor = (resp, product_id) => {
		// let data = { data: styleAdvisor, id: product_id };
		let length = resp.complimentary_products.length - 1;

		Axios.post(window['BASE_URL'] + `/search/semantic`, {
			input_text: '',
			tenant_id: tenantId.toString(),
			bot_id: botId.toString(),
			version: 'prod',
			generic_response: '',
			product_intent: '',
			queries: resp.complimentary_products,
		}).then((resp) => {
			resp.data.similar_content.length &&
				setStyleAdvisor((styleAdvisor) => [
					...styleAdvisor,
					resp.data.similar_content,
				]);
		});
	};
	const restartSession = () => {
		var date = new Date();
		var timestamp = Math.floor(date.getTime() / 1000.0);
		var usertenantID = encryptText(`${tenantId}:${timestamp}`);
		const endpoint =
			window.location.origin.indexOf('localhost') > -1 ||
				window.location.origin.indexOf('https://dev.flyfish.ai') > -1
				? window['BASE_URL']
				: window.location.origin.indexOf('uat.flyfish.ai') > -1
					? 'https://uat.flyfish.ai'
					: window.location.origin.indexOf('preprod.flyfish.ai') > -1
						? 'https://preprod.flyfish.ai'
						: window['BASE_URL'];
		Axios.post(
			endpoint + `/authentication/anonynousLogin`,
			{
				name: 'anonymous',
				email: 'anonymousEmail',
				teamId: usertenantID,
			},
			{
				headers: {
					'x-tenant-id': tenantId,
				},
			}
		).then((response) => {
			let token = response.data.data.token;
			changeToken(token);
			queryText && submitChat();
			// let sessionIDFORM = response.data.data.createdTime;
		});
	};
	const showCartData = () => {
		setShowCart(true);
	};
	const handleFilter = () => {
		let sortedProducts = [];
		const topProducts = metaData.products.filter(
			(product) => product.category === 'Top Products'
		);
		if (filterCheckboxValues === 'Sort by Price Low to High') {
			topProducts.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
		} else if (filterCheckboxValues === 'Sort by Price High to Low') {
			topProducts.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
		} else if (filterCheckboxValues === 'Sort by Newest Arrivals') {
			const parseDate = (dateString: string): Date => new Date(dateString);
			topProducts.sort(
				(a, b) =>
					parseDate(b.updated_on).getTime() - parseDate(a.updated_on).getTime()
			);
		} else if (filterCheckboxValues === 'Sort by Deals and Discounts') {
			topProducts.forEach((product) => {
				const discountPercentage = getDiscount(
					product.price,
					product.sale_price
				);
				topProducts.discountPercentage = discountPercentage;
			});
			topProducts.sort((a, b) => b.discountPercentage - a.discountPercentage);
		}
		if (filterCheckboxValues === 'Filter by Customer Ratings') {
			topProducts.sort((a, b) => parseFloat(b.rating) - parseFloat(a.rating));
		}

		const otherProducts = metaData.products.filter(
			(product) => product.category !== 'Top Products'
		);
		sortedProducts = [...otherProducts, ...topProducts];
		let tempArray = metaData;
		tempArray.products = sortedProducts;
		tempArray = { ...tempArray, sorted: filterCheckboxValues };
		setMetaData(tempArray);
	};
	const getTitleMessage = (title) => {
		setTitle(title);
	};
	const submitFeedback = (star = false, comment = '', msgRate, msgId) => {
		setIsModalVisible(false);
		let payload = {
			id: 0,
			conversationId: responseId,
			messageId: msgId ? msgId : 0,
			botId: botId,
			rating: star,
			msgRating: msgRate ? msgRate : 0,
			feedBackText: comment,
		};
		fetch(
			'https://' + window['CHAT_URL'] + `/configuration/${tenantId}/feedBack`,
			{
				credentials: 'include',
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'x-tenant-id': tenantId,
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify(payload),
			}
		)
			.then((data) => data.json())
			.then((response) => {
				handleToaster();
			});
		const updatedData = chatMessages.map((item) => {
			return item.map((type) => {
				if (type.chatMessageDataServer.messageId === msgId) {
					return {
						...type,
						chatMessageDataServer: {
							...type.chatMessageDataServer,
							thumbFilledUp: thumbFilledUp,
						},
					};
				}

				return type;
			});
		});
		setChatMessages(updatedData);
		if (msgRate > 0) {
			// chatMessages.filter(
			// 	(item) => item[0].chatMessageDataServer.messageId === msgId
			// )[0].thumbFilledUp;
			// this.state.chatMessages &&
			// 	this.state.chatMessages.map((valdata: any) => {
			// 		if (Object.keys(valdata).indexOf('messageId') > -1) {
			// 			if (valdata.messageId === this.state.messageId) {
			// 				return (valdata.thumbFilledUp = msgRate === 4 ? true : false);
			// 			}
			// 		}
			// 	});
		}
	};
	useEffect(() => {
		console.log('chatMessage', chatMessages);
	}, [chatMessages]);

	return (
		<>
			<EcomContainer
				colorMode={colorMode}
				queriesFound={chatMessages.length > 0}
				className='ff-ecom-theme-container'
			>
				<EcomThemeDiv colorMode={colorMode} className='ff-ecom-theme'>
					<Input
						className='ff-ecom-input'
						placeholder='Type in message'
						autoComplete='off'
						value={queryText}
						onClick={() => {
							setShowExistingQueries(!showExistingQueries);
						}}
						onChange={(ev) => {
							setShowExistingQueries(false);
							setQueryText(ev.target.value.trimStart());
						}}
						onKeyDown={(e) => {
							if (e.key.toLowerCase() === 'enter') {
								queryText.trimStart().length && submitChat();
								// @ts-ignore
								e.target.blur();
							}
						}}
						endIcon={
							<>
								<svg
									onClick={() => {
										queryText.trimStart().length && submitChat();
									}}
									style={{ cursor: 'pointer', marginRight: '8px' }}
									xmlns='http://www.w3.org/2000/svg'
									id='send-icn'
									width='18'
									height='18'
									viewBox='0 0 13.014 15.069'
								>
									<g
										id='Path_6'
										data-name='Path 6'
										transform='translate(13.014) rotate(90)'
									>
										<path
											d='M 0.9947404265403748 12.04445552825928 L 7.534533500671387 0.7484385967254639 L 14.07432556152344 12.04445266723633 L 7.714113712310791 8.575236320495605 L 7.534543514251709 8.477286338806152 L 7.354973316192627 8.575236320495605 L 0.9947404265403748 12.04445552825928 Z'
											stroke='none'
											fill={
												colorMode === 'dark'
													? 'var(--colorScale-3)'
													: 'var(--colorScale-0'
											}
										/>
										<path
											d='M 7.534533500671387 1.496898651123047 L 1.989492416381836 11.07470607757568 L 7.534543514251709 8.050126075744629 L 13.0795726776123 11.0747013092041 L 7.534533500671387 1.496898651123047 M 7.534533500671387 -3.814697265625e-06 L 15.06906318664551 13.01419639587402 L 7.534543514251709 8.904445648193359 L 3.814697265625e-06 13.01419639587402 L 7.534533500671387 -3.814697265625e-06 Z'
											stroke='none'
											fill={
												colorMode === 'dark'
													? 'var(--colorScale-3)'
													: 'var(--colorScale-0'
											}
										/>
									</g>
								</svg>
								<div
									className='division'
									style={{
										position: 'absolute',
										top: '1px',
										right: '40px',
										height: '96%',
										width: '1px',
									}}
								></div>

								<svg
									className={`chat-icon-svg ${showExistingQueries && chatMessages.length > 0
										? 'active'
										: !showExistingQueries && chatMessages.length > 0
											? 'enable'
											: 'disable'
										}`}
									onClick={(e) => {
										setShowExistingQueries(!showExistingQueries);
										setShowFilter(false);
									}}
									xmlns='http://www.w3.org/2000/svg'
									width='21.25'
									height='19.788'
									viewBox='0 0 21.25 19.788'
								>
									<g
										id='Chat_disabled'
										data-name='Chat disabled'
										transform='translate(-367.875 -1196.605)'
									>
										<path
											id='Path_20560'
											data-name='Path 20560'
											d='M19.817,4.5H5.933A2.565,2.565,0,0,0,3.375,7.058v8.769a2.565,2.565,0,0,0,2.558,2.558H7.76v3.654l4.28-3.569a.365.365,0,0,1,.234-.085h7.543a2.565,2.565,0,0,0,2.558-2.558V7.058A2.565,2.565,0,0,0,19.817,4.5Z'
											transform='translate(365.625 1193.23)'
											fill='none'
											stroke='#ccc'
											stroke-linejoin='round'
											stroke-width='2.25'
										/>
										<path
											id='Path_20561'
											data-name='Path 20561'
											d='M11.923,14.4a1.462,1.462,0,1,1-1.462-1.462A1.462,1.462,0,0,1,11.923,14.4Z'
											transform='translate(363.654 1190.274)'
											fill='#d6d6d6'
										/>
										<path
											id='Path_20562'
											data-name='Path 20562'
											d='M18.673,14.4a1.462,1.462,0,1,1-1.462-1.462A1.462,1.462,0,0,1,18.673,14.4Z'
											transform='translate(361.289 1190.274)'
											fill='#ddd'
										/>
										<path
											id='Path_20563'
											data-name='Path 20563'
											d='M25.423,14.4a1.462,1.462,0,1,1-1.462-1.462A1.462,1.462,0,0,1,25.423,14.4Z'
											transform='translate(358.923 1190.274)'
											fill='#cecece'
										/>
									</g>
								</svg>
							</>
						}
					/>
					{showBackButton ? (
						<div
							className='back-button'
							onClick={() => {
								setShowCart(false);
								setShowBackButton(false);
								storeStyle();
								setStyleAdvisor('');
							}}
						>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='7.471'
								height='12.113'
								viewBox='0 0 7.471 12.113'
							>
								<path
									id='Back'
									d='M18404.566,128.625l-5.35,5.349,5.35,5.349'
									transform='translate(-18397.803 -127.918)'
									fill='none'
									stroke='#111'
									stroke-width='2'
								/>
							</svg>
							<div>Back</div>
						</div>
					) : null}

					<div
						className={`filter ${metaData &&
							metaData.products &&
							metaData.products.length &&
							!showCart
							? 'show'
							: 'hide'
							}`}
						ref={filterRef}
					>
						{
							<div>
								<div
									onClick={() => {
										setShowFilter(!showFilter);
										setShowExistingQueries(false);
									}}
								>
									<p>Filters</p>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='20px'
										viewBox='0 0 20 20'
										fill='none'
										stroke='currentColor'
										stroke-width='2'
										stroke-linecap='round'
										stroke-linejoin='round'
									>
										<polyline points='6 9 12 15 18 9' />
									</svg>
								</div>
								{showFilter && (
									<div className='ff-filter-radio'>
										<RadioGroup
											aria-labelledby='ff-filter-radio-label'
											name='ff-filter-radio'
											value={filterCheckboxValues}
											onChange={(ev) => {
												setFilterCheckboxValues(
													(event.target as HTMLInputElement).value
												);
											}}
										>
											{filterArray.map((item) => (
												<FormControlLabel
													value={item}
													key={item}
													control={<Radio />}
													label={
														<p
															className='ff-chatbot-body2'
															onClick={() => {
																setFilterCheckboxValues(item);
															}}
														>
															{item}
														</p>
													}
												/>
											))}
										</RadioGroup>
										<div className='ff-button-filter'>
											<Button
												onClick={() => {
													handleFilter();
													setShowFilter(false);
												}}
											>
												Apply
											</Button>
										</div>
									</div>
								)}
							</div>
						}
					</div>
				</EcomThemeDiv>

				{showExistingQueries && (
					<div className='options'>
						{chatMessages.length > 0 ? (
							<div className='querytext-holder' ref={optionsRef}>
								<>
									{[...chatMessages].reverse().map((message, index) => {
										return (
											<div className='user-query-bot-response'>
												<div className='user-query'>
													{message[0].chatMessageDataUser.message}
												</div>
												<div
													className='bot-response'
													onClick={() => {
														setSelectedMessageIndex(index);
														saveStateSession('queryText', queryText);
														saveStateSession('FF-topProducts-counter', 1);
														setQueryText(
															message[0].chatMessageDataUser.message
														);
														setTime(message[0].chatMessageDataServer.timeStamp);
														setMessage(
															message[0].chatMessageDataServer.message.message
														);
														setMsgId(
															message[0].chatMessageDataServer.messageId
														);
														setMetaData(
															message[0].chatMessageDataServer.message.metaData
														);

														let arr = [
															{
																category:
																	message[0].chatMessageDataServer.message
																		.metaData &&
																	message[0].chatMessageDataServer.message
																		.metaData.categories &&
																	message[0].chatMessageDataServer.message
																		.metaData.categories[0],
																products:
																	message[0].chatMessageDataServer.message
																		.metaData.products,
																rows: 1,
															},
														];

														setCategoriesProductsArray(arr);

														setShowCart(false);
														setShowBackButton(false);
														setShowExistingQueries(false);
														setReasonAPIPayload({
															id:
																message[0].chatMessageDataServer.message
																	.conversationalId,
															message: message[0].chatMessageDataUser.message,
															botId: botId.toString(),
															version: 'prod',
															country: country,
														});
														setShowChat(true);
														setUpdate(!update);
													}}
												>
													<svg
														xmlns='http://www.w3.org/2000/svg'
														width='14.789'
														height='13.623'
														viewBox='0 0 14.789 13.623'
													>
														<g
															id='icon_1'
															data-name='icon 1'
															transform='translate(-3.75 -6.439)'
														>
															<path
																id='Path_20499'
																data-name='Path 20499'
																d='M8.191,7.5,4.5,11.191l3.691,3.691'
																transform='translate(0 0)'
																fill='none'
																stroke={`${colorMode === 'dark'
																	? 'var(--colorScale-3)'
																	: 'var(--colorScale-0)'
																	}`}
																stroke-linecap='round'
																stroke-linejoin='round'
																stroke-width='1.5'
															/>
															<path
																id='Path_20500'
																data-name='Path 20500'
																d='M4.5,15h5.906a7.383,7.383,0,0,1,7.383,7.383v.738'
																transform='translate(0 -3.809)'
																fill='none'
																stroke={`${colorMode === 'dark'
																	? 'var(--colorScale-3)'
																	: 'var(--colorScale-0)'
																	}`}
																stroke-linecap='round'
																stroke-linejoin='round'
																stroke-width='1.5'
															/>
														</g>
													</svg>
													<div
														dangerouslySetInnerHTML={{
															__html:
																message[0].chatMessageDataServer.message
																	.message,
														}}
													></div>
												</div>
											</div>
										);
									})}
									<hr />
									{trendingSearch && trendingSearch.length ? (
										<div className='trending-advisor-holder'>
											<div className='trending'>
												<div>TRENDING SEARCHES</div>
												{trendingSearch.map((item) => {
													return (
														<div
															className='trending-item'
															onClick={() => {
																setQueryText(item);
																submitChat();
															}}
														>
															<TrendingIcon />
															<div>{item}</div>
														</div>
													);
												})}
											</div>
											{/* <div className='style-advisor'>
									<div>STYLE ADVISOR</div>
									<div>TRENDING</div>
								</div> */}
										</div>
									) : null}
								</>
							</div>
						) : null}

						{/* just a placeholder below div mandatory to fill certain aspects*/}
						<div className='placeholder-filter'>
							<p>Filters</p>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='22'
								height='22'
								viewBox='0 0 24 24'
								fill='none'
								stroke='currentColor'
								stroke-width='2'
								stroke-linecap='round'
								stroke-linejoin='round'
							>
								<polyline points='6 9 12 15 18 9' />
							</svg>
						</div>
					</div>
				)}
				<>
					{loader ? (
						<div className='chat-loader'>
							<ChatLoader />
						</div>
					) : (
						<>
							{showChat ? (
								<EcomChats
									storeStyle={storeStyle}
									messageId={msgId}
									handleSubmit={(data) => {
										setQueryText(data), submitChat();
									}}
									botId={botId}
									queryText={queryText}
									styleAdvisorCache={styleAdvisorCache}
									styleAdvisor={styleAdvisor}
									handleStyleAdvisor={handleStyleAdvisor}
									getTitleMessage={getTitleMessage}
									message={
										showCart
											? title
												? 'Great you have selected ' + title
												: ''
											: message
									}
									metaData={metaData}
									token={token}
									tenantId={tenantId}
									time={time}
									showBack={showBack}
									showCartData={showCartData}
									showCart={showCart}
									reasonAPIPayload={reasonAPIPayload}
									secondAPI={
										metaData && metaData.get_products === 'true' ? true : false
									}
									responseId={responseId}
									colorMode={colorMode}
									setSelectedProductData={(data) => {
										setSelectedProductData(data);
									}}
									conversationId={responseId}
									categoriesProductsArray={categoriesProductsArray}
									setTopProductsRowsCounter={setTopProductsRowsCounter}
									openThumbsPopup={openThumbsPopup}
									thumbFilledUp={
										chatMessages.length > 0 &&
										chatMessages
											.flat()
											.filter(
												(item) => item.chatMessageDataServer.messageId === msgId
											)[0]?.chatMessageDataServer?.thumbFilledUp
									}
									popUpSnackBar={popUpSnackBar}
									enableStyleAdvisor={enableStyleAdvisor}
									advisorTitle={advisorTitle}
								/>
							) : null}
						</>
					)}
				</>
			</EcomContainer>
			{isModalVisible && (
				<SFModal isModalVisible={true}>
					<MessageFeedbackComment
						msgKey={true}
						data={''}
						popUpSnackBar={popUpSnackBar}
						selectedRating={0}
						messageFeedbackCallback={() => {
							console.log('messageFeedbackCallback');
						}}
						messageFeedbackPrevVal={null}
						submitFeedback={submitFeedback}
						thumbFilledUp={thumbFilledUp}
						thumbFilledDown={null}
						messageId={msgId}
						colorMode={colorMode}
						openThumbsPopup={openThumbsPopup}
					/>
				</SFModal>
			)}
		</>
	);
};

export default EcomNewSearch;
